import {
  INSERT_ORDERED_LIST_COMMAND,
  INSERT_UNORDERED_LIST_COMMAND,
} from "@lexical/list";
import type { LexicalEditor } from "lexical";

export type CanvasListType = "bullet" | "dash" | "numbered";

/** Applies a list style via Lexical list commands (dash uses bullets until dash styling lands). */
export function applyCanvasListType(
  editor: LexicalEditor | null,
  type: CanvasListType,
): void {
  if (!editor) return;
  if (type === "numbered") {
    editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, undefined);
    return;
  }
  editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, undefined);
}
